function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames"],
  _excluded2 = ["attributes", "children", "nodeProps", "styles", "classNames", "prefixClassNames", "leaf", "text"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _styled from 'styled-components';
import React from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(_StyledDiv$1, props);
};
var _StyledDiv$1 = _styled("div").withConfig({
  displayName: "Divider___StyledDiv",
  componentId: "sc-n6iu2k-0"
})({
  "marginLeft": "0.5rem",
  "marginRight": "0.5rem",
  "marginTop": "0.125rem",
  "marginBottom": "0.125rem",
  "width": "1px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(229, 231, 235, var(--tw-bg-opacity))"
});
var PortalBody = function PortalBody(_ref) {
  var children = _ref.children,
    element = _ref.element;
  return /*#__PURE__*/ReactDOM.createPortal(children, element || document.body);
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray_1(value) ? value : [value];
}
var castArray_1 = castArray;
var createStyles = function createStyles(props, styles) {
  var stylesArray = castArray_1(styles);
  var allStyles = {};
  stylesArray.forEach(function (_styles) {
    Object.keys(_styles).forEach(function (key) {
      var _allStyles$key$css;
      var _props$classNames, _props$styles;
      var cssProp = castArray_1(_styles[key]); // Init css and className props

      if (!allStyles[key]) {
        var className = '';
        if (props.prefixClassNames) {
          if (key === 'root') {
            className = "slate-".concat(props.prefixClassNames);
          } else {
            className = "slate-".concat(props.prefixClassNames, "-").concat(key);
          }
        }
        allStyles[key] = {
          css: cssProp,
          className: clsx(props.prefixClassNames && className)
        };
      } // Extend className with `classNames` prop

      var classNameProp = props === null || props === void 0 ? void 0 : (_props$classNames = props.classNames) === null || _props$classNames === void 0 ? void 0 : _props$classNames[key];
      if (classNameProp) {
        allStyles[key].className = clsx(allStyles[key].className, classNameProp);
      } // Extend css with `styles` prop

      var cssPropOverride = props === null || props === void 0 ? void 0 : (_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles[key];
      if (!cssPropOverride) return;
      var cssPropOverrideArray = castArray_1(cssPropOverride);
      (_allStyles$key$css = allStyles[key].css).push.apply(_allStyles$key$css, _toConsumableArray(cssPropOverrideArray));
    });
  });
  return allStyles;
};
var getStyledNodeStyles = function getStyledNodeStyles(props) {
  return createStyles(props, {
    root: [{}]
  });
};

/**
 * StyledElement with no default styles.
 */
var StyledElement = function StyledElement(props) {
  var _styles$root, _nodeProps$styles$roo, _nodeProps$styles, _nodeProps$styles$roo2;
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    rootProps = _objectWithoutProperties(props, _excluded);
  var rootStyles = castArray_1((_styles$root = styles === null || styles === void 0 ? void 0 : styles.root) !== null && _styles$root !== void 0 ? _styles$root : []);
  var nodePropsStyles = (_nodeProps$styles$roo = nodeProps === null || nodeProps === void 0 ? void 0 : (_nodeProps$styles = nodeProps.styles) === null || _nodeProps$styles === void 0 ? void 0 : (_nodeProps$styles$roo2 = _nodeProps$styles.root) === null || _nodeProps$styles$roo2 === void 0 ? void 0 : _nodeProps$styles$roo2.css) !== null && _nodeProps$styles$roo !== void 0 ? _nodeProps$styles$roo : [];
  var _getStyledNodeStyles = getStyledNodeStyles(_objectSpread(_objectSpread({}, nodeProps), {}, {
      styles: {
        root: [].concat(_toConsumableArray(rootStyles), _toConsumableArray(nodePropsStyles))
      }
    })),
    root = _getStyledNodeStyles.root;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, attributes, rootProps, nodeProps, {
    $_css: root.css
  }), children);
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "StyledElement___StyledDiv",
  componentId: "sc-2e063k-0"
})(["", ""], function (p) {
  return p.$_css;
});

/**
 * StyledLeaf with no default styles.
 */
var StyledLeaf = function StyledLeaf(props) {
  var _styles$root, _nodeProps$styles$roo, _nodeProps$styles, _nodeProps$styles$roo2;
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    leaf = props.leaf,
    text = props.text,
    rootProps = _objectWithoutProperties(props, _excluded2);
  var rootStyles = castArray_1((_styles$root = styles === null || styles === void 0 ? void 0 : styles.root) !== null && _styles$root !== void 0 ? _styles$root : []);
  var nodePropsStyles = (_nodeProps$styles$roo = nodeProps === null || nodeProps === void 0 ? void 0 : (_nodeProps$styles = nodeProps.styles) === null || _nodeProps$styles === void 0 ? void 0 : (_nodeProps$styles$roo2 = _nodeProps$styles.root) === null || _nodeProps$styles$roo2 === void 0 ? void 0 : _nodeProps$styles$roo2.css) !== null && _nodeProps$styles$roo !== void 0 ? _nodeProps$styles$roo : [];
  var _getStyledNodeStyles2 = getStyledNodeStyles(_objectSpread(_objectSpread({}, nodeProps), {}, {
      styles: {
        root: [].concat(_toConsumableArray(rootStyles), _toConsumableArray(nodePropsStyles))
      }
    })),
    root = _getStyledNodeStyles2.root;
  return /*#__PURE__*/React.createElement(_StyledSpan, _extends({}, attributes, rootProps, nodeProps, {
    $_css: root.css
  }), children);
};
var _StyledSpan = _styled("span").withConfig({
  displayName: "StyledLeaf___StyledSpan",
  componentId: "sc-129cvv1-0"
})(["", ""], function (p) {
  return p.$_css;
});

/**
 * HOC mapping element/leaf props to component styles
 */
var withStyledProps = function withStyledProps(Component, _ref2) {
  var _ref2$elementProps = _ref2.elementProps,
    elementProps = _ref2$elementProps === void 0 ? {} : _ref2$elementProps,
    _ref2$leafProps = _ref2.leafProps,
    leafProps = _ref2$leafProps === void 0 ? {} : _ref2$leafProps;
  return function (_props) {
    var element = _props.element,
      leaf = _props.leaf;
    var styles = {
      root: {}
    };
    Object.keys(elementProps).forEach(function (nodeProp) {
      var cssPropKeys = castArray_1(elementProps[nodeProp]);
      cssPropKeys.forEach(function (key) {
        styles.root[key] = element[nodeProp];
      });
    });
    Object.keys(leafProps).forEach(function (nodeProp) {
      var cssPropKeys = castArray_1(leafProps[nodeProp]);
      cssPropKeys.forEach(function (key) {
        styles.root[key] = leaf[nodeProp];
      });
    });
    return /*#__PURE__*/React.createElement(Component, _extends({}, _props, {
      styles: styles
    }));
  };
};
export { Divider, PortalBody, StyledElement, StyledLeaf, createStyles, getStyledNodeStyles, withStyledProps };